import Image from 'next/image'

const PayPal = () => {
  return (
    <div className="flex w-4 h-4 mt-1">
      <Image
        src="/icons/payment/paypal.svg"
        alt=""
        width={256}
        height={302}
        className="w-full h-auto"
        placeholder="empty"
      />
    </div>
  )
}

const MasterCard = () => {
  return (
    <div className="flex w-4 h-4 mt-1">
      <Image
        src="/icons/payment/mastercard.svg"
        alt=""
        width={256}
        height={199}
        className="w-full h-auto"
        placeholder="empty"
      />
    </div>
  )
}

const Visa = () => {
  return (
    <div className="flex w-4 h-4 mt-1">
      <Image
        src="/icons/payment/visa.svg"
        alt=""
        width={256}
        height={83}
        className="w-full h-auto"
        placeholder="empty"
      />
    </div>
  )
}

const Amex = () => {
  return (
    <div className="flex w-4 h-4 mt-1">
      <Image
        src="/icons/payment/amex.svg"
        alt=""
        width={256}
        height={256}
        className="w-full h-auto"
        placeholder="empty"
      />
    </div>
  )
}

// NOTE: From heroicons
const Creditcard = () => {
  return (
    <div className="flex w-4 h-4 mt-1 text-red-500">
      <Image
        src="/icons/payment/creditcard.svg"
        alt=""
        width={24}
        height={24}
        className="w-full h-auto"
        placeholder="empty"
      />
    </div>
  )
}

const PaymentMethodLogo = ({ paymentMethod }: { paymentMethod: string }) => {
  let logo = undefined
  switch (paymentMethod) {
    case 'PayPal':
      logo = <PayPal />
      break
    case 'MasterCard':
      logo = <MasterCard />
      break
    case 'Amex':
      logo = <Amex />
      break
    case 'Visa':
      logo = <Visa />
      break
    default:
      logo = <Creditcard />
      break
  }
  return logo
}

export default PaymentMethodLogo
